var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container',{staticClass:"bg-white",attrs:{"title":_vm.$i18n('globals.type.regions_menu'),"tag":"regionSideNav"}},[_c('NavRegionsLinkEntry',{attrs:{"entry":_vm.regionMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }